var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.387 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.188 6.863.138 3.812a.47.47 0 0 1 0-.664L.8 2.484a.47.47 0 0 1 .664 0L3.52 4.54l4.4-4.4a.47.47 0 0 1 .664 0l.664.664a.47.47 0 0 1 0 .664l-5.4 5.4a.47.47 0 0 1-.664 0Z"
  })));
};
export default SvgCheck;